import React, { useEffect, useRef, useState } from 'react'
import { useHeaderContext } from '../../../../context/provider/HeaderProvider';
import ContenedorIncidenciasInspectoria from './ContenedorIncidenciasInspectoria';
import ContenedorIndicadoresOperacion from './ContenedorIndicadoresOperacion';
import '../../../../assets/css/CentroMonitoreo/CentroMonitoreo.css'
import { useCentroMonitoreo } from '../../../../hooks/monitoreo/useCentroMonitoreo';
import { Modal } from '../../../components/modal/Modal';
import ContenedorModalMonitoreo from './ContenedorModalMonitoreo';
import { useModal } from '../../../../hooks/useModal';
import ModalCentroMonitoreo from '../../../components/modal/ModalCentroMonitoreo';
import PantallaCargaInterna from '../../../components/forms/PantallaCargaInterna';
import { classNameInput, ObtenerFechaActual } from '../../../../utils/utils';
import ContenedorSeguimiento from './ContenedorSeguimiento';

const CentroMonitoreo = () => {
  const { showHeader, setShowHeader } = useHeaderContext();
  const hookCentroMonitoreo = useCentroMonitoreo()
  const refIntervalEmpresas = useRef()
  const [isOpenPestaniaIzquierda, setIsOpenPestaniaIzquierda] = useState(false)
  const [isOpenPestaniaDerecha, setIsOpenPestaniaDerecha] = useState(false)
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(0)
  const [nombreEmpresaSeleccionada, setNombreEmpresaSeleccionada] = useState('')
  const [rutaSeleccionada, setRutaSeleccionada] = useState(0)
  const [nombreRutaSeleccionada, setNombreRutaSeleccionada] = useState('')
  const [isOpenModalTrack, openModalTrack, closeModalTrack] = useModal()
  const [isOpenModalSeguimiento, openModalSeguimiento, closeModalSeguimiento] = useModal()
  

  useEffect(() => {
    setShowHeader(false)    //PARA OCULTAR EL HEADER EN ESTE COMPONENTE
    hookCentroMonitoreo.listarEmpresas()
    refIntervalEmpresas.current = setInterval(() => {
      hookCentroMonitoreo.listarEmpresas()  
    }, (60000));
    return(() => {
      clearInterval(refIntervalEmpresas.current)
      setShowHeader(true)
    })
  },[])

  return (
    <>
      {
        Object.entries(hookCentroMonitoreo.arregloEmpresas).length != 0
        ? <></>
        : <PantallaCargaInterna></PantallaCargaInterna>
      }
      <div className='w-full h-full flex'>
        <section 
          className={`${isOpenPestaniaIzquierda ? 'w-[350px]' : 'w-0'} transition-all duration-500 h-full relative`}
        >
          {
            isOpenPestaniaIzquierda
            ? <ContenedorIncidenciasInspectoria key={empresaSeleccionada} codEmpresa={empresaSeleccionada} />
            : <></>
          }
          <div onClick={() => setIsOpenPestaniaIzquierda(!isOpenPestaniaIzquierda)} className='hover:bg-blue-800 transition duration-200 cursor-pointer absolute w-[30px] h-[60px] right-0 translate-x-full top-1/2 -translate-y-1/2 bg-blue-600 z-50 content-center text-center rounded-r-2xl'><i className={`fas ${isOpenPestaniaIzquierda ? 'fa-caret-left' : 'fa-caret-right'}`}></i></div>
        </section>
        <section className='flex-1 overflow-auto containerScroll'>
          <table id="tablaEmpresasGeneral" className='table'>
              <thead>
                <tr>
                  <th rowSpan={2}>Nº</th>
                  <th rowSpan={2}>EMPRESA</th>
                  <th rowSpan={2}>RUTA</th>
                  <th colSpan={3}>FLOTA VEHICULAR</th>
                  <th colSpan={3}>OPERACIÓN</th>
                  <th colSpan={5}>INDICADORES</th>
                  <th rowSpan={2} className='w-[200px]'>SEGUIMIENTO</th>
                  <th rowSpan={2}>OPC</th>
                </tr>
                <tr>
                  <th>TOTAL</th>
                  <th>OPERATIVA</th>
                  <th>PORCENTAJE</th>
                  <th>VIAJES</th>
                  <th>KM</th>
                  <th>PASAJEROS</th>
                  <th>PB</th>
                  <th>IPK</th>
                  <th>IPB</th>
                  <th>PP</th>
                  <th>IKB</th>
                </tr>
              </thead>
              <tbody>
                {
                  Object.entries(hookCentroMonitoreo.arregloEmpresas).map(([clave,valor],i) => (
                    valor.map((data,j) => (
                      <tr 
                        key={`${i}_${j}`} 
                        onClick={() => {
                          setEmpresaSeleccionada(data.codEmpresa)
                          setRutaSeleccionada(data.codRuta)
                          setNombreEmpresaSeleccionada(data.nomEmpresa)
                          setNombreRutaSeleccionada(data.nomRuta)
                        }}
                      >
                        {
                          j == 0
                          ? <>
                              <td className='text-center' rowSpan={valor.length}>{i+1}</td>
                              <td rowSpan={valor.length} className={empresaSeleccionada == data.codEmpresa ? 'text-blue-600 font-bold' : ''}>{clave}</td>
                            </>
                          : <></>
                        }
                        <td className={(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}>{data.nomRuta}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{data.flotaTotal}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{data.flotaOperativa}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{Number(data.porcentajeFlotaOperativa || 0).toFixed(2)} %</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{data.numViajes}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{Number(data.kilometros || 0).toFixed(2)}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{data.totalPasajeros}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{Number(data.pb || 0).toFixed(2)}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{Number(data.ipk || 0).toFixed(2)}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{Number(data.ipb || 0).toFixed(2)}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{Number(data.pp || 0).toFixed(2)}</td>
                        <td className={`text-right ${(rutaSeleccionada == data.codRuta && empresaSeleccionada == data.codEmpresa) ? 'text-blue-600 font-bold' : ''}`}>{Number(data.ikb || 0).toFixed(2)}</td>
                        <td className='text-right'>
                          <div onClick={openModalSeguimiento} className='max-w-[200px] overflow-auto containerScroll flex'>
                            {
                              data.cantidadSeguimiento != 0
                              ? Array.from({length: data.cantidadSeguimiento})
                                .map((_,i) => (
                                  <div 
                                    key={i+1} 
                                    onClick={openModalSeguimiento} 
                                    className='content-center text-center w-[20px] h-[20px] flex-shrink-0 rounded-[4px] border border-gray-400 bg-blue-600 text-xs'
                                  >{i+1}</div>
                                ))
                              : <div 
                                  onClick={openModalSeguimiento} 
                                  className='content-center text-center w-[20px] h-[20px] flex-shrink-0 rounded-[4px] border border-gray-400 bg-green-600 text-xs'
                                ><i className='fas fa-plus'></i></div>
                            }
                          </div>
                        </td>
                        <td className='text-center'><button onClick={openModalTrack} className='rounded bg-yellow-600 px-3 content-center text-xs'><i className="fa fa-globe" aria-hidden="true"></i> Ver</button></td>
                      </tr>
                    ))
                  )).flat()
                }
              </tbody>
          </table>
        </section>
        <section className={`${isOpenPestaniaDerecha ? 'w-[350px]' : 'w-0'} transition-all duration-500 h-full relative`}>
          {
            isOpenPestaniaDerecha
            // ? <ContenedorIndicadoresOperacion key={empresaSeleccionada} codEmpresa={empresaSeleccionada} />  // SE ESTA MANDANDO TODAS LAS EMPRESAS POR EL MOMENTO
            ? <ContenedorIndicadoresOperacion codEmpresa={0} />
            : <></>
          }
          <div onClick={() => setIsOpenPestaniaDerecha(!isOpenPestaniaDerecha)} className='hover:bg-blue-800 transition duration-200 cursor-pointer absolute w-[30px] h-[60px] left-0 -translate-x-full top-1/2 -translate-y-1/2 bg-blue-600 z-50 content-center text-center rounded-l-2xl'><i className={`fas ${isOpenPestaniaDerecha ? 'fa-caret-right' : 'fa-caret-left'}`}></i></div>
        </section>
      </div>

      <ModalCentroMonitoreo
          isOpen={isOpenModalTrack}
          closeModal={closeModalTrack}
          title={`${nombreEmpresaSeleccionada} - ${nombreRutaSeleccionada}`}
      >
        {
          isOpenModalTrack
          ? <ContenedorModalMonitoreo 
              key={`${empresaSeleccionada}_${rutaSeleccionada}_${nombreEmpresaSeleccionada}_${nombreRutaSeleccionada}`} 
              codEmpresa={empresaSeleccionada} 
              codRuta={rutaSeleccionada} 
              nombreEmpresaSeleccionada={nombreEmpresaSeleccionada}
              nombreRutaSeleccionada={nombreRutaSeleccionada}
            />
          : <></>
        }
      </ModalCentroMonitoreo>

      <Modal
        title={`Seguimiento Empresa: [${nombreEmpresaSeleccionada}] - Ruta: [${nombreRutaSeleccionada}]`}
        isOpen={isOpenModalSeguimiento}
        closeModal={() => {
          hookCentroMonitoreo.listarEmpresas()
          closeModalSeguimiento()
        }}
        validButton={{denied: true, confirm: false}}
        textButtons={{denied: 'Cerrar'}}
      >
        {
          isOpenModalSeguimiento
          ? <ContenedorSeguimiento
              key={`${empresaSeleccionada}_${rutaSeleccionada}`}
              fechaInicio={ObtenerFechaActual()}
              fechaFin={ObtenerFechaActual()}
              codEmpresa={empresaSeleccionada}
              codRuta={rutaSeleccionada}
              nomRuta={nombreRutaSeleccionada}
            />
          : <></>
        }
      </Modal>
    </>
  )
}

export default CentroMonitoreo